import { HELOCTerms } from '../HELOCTerms'
import { MediaImageStandard } from '@/components/Contentful'
import { useHeloc } from './HelocContext'
import { Typography } from 'components/Contentful'
import classNames from 'classnames'

export const HelocOutput = ({
  content,
  outputImage,
  variant,
  helocUpdated,
  recalculate,
  textContent,
  ref,
}) => {
  const { state, dispatch } = useHeloc()
  return (
    <>
      {variant === 'updated' ? (
        <>
          {state.helocOutput ? (
            <HELOCTerms
              recalculate={recalculate}
              content={content}
              helocOutput={state.helocOutput}
              key="output-section"
              setEquityError={(value) => dispatch({ type: 'SET_EQUITY_ERROR', payload: value })}
              helocUpdated={helocUpdated}
              ref={ref}
            />
          ) : (
            <>
              <div
                ref={ref}
                className="flex flex-col mt-16 lg:mt-0 w-full lg:w-1/2 hidden lg:block"
              >
                <div
                  className="border-2 border-[#D2E2FE] border-solid rounded-[10px] bg-white"
                  data-testid="heloc-calculator-output-container"
                >
                  <div className="flex flex-row items-center justify-center mt-8">
                    <MediaImageStandard
                      className="h-[200px] w-[200px]"
                      alt={outputImage.altText}
                      content={outputImage.mediaContent}
                      layout="fixed"
                    />
                  </div>
                  <div className="px-32 py-4 m-2" data-testid="heloc-calculator-output-title">
                    <Typography
                      fontWeight="bold"
                      className={classNames(
                        'text-center text-[1.5rem] leading-[130%] lg:leading-[120%] lg:tracking-[-0.01em]'
                      )}
                      content={
                        textContent?.rightPanelTitle ??
                        'Use the HELOC calculator to check how much you could borrow'
                      }
                    />
                  </div>
                  <div className="px-16 mb-16" data-testid="heloc-calculator-output-subtitle">
                    <Typography
                      content={
                        textContent?.rightPanelSubtitle ??
                        'Enter your home value, mortgage balance, loan amount, credit score, and state on the left to see your results. With enough equity, you could qualify for offers up to $700,000.'
                      }
                    />
                  </div>
                </div>
              </div>
            </>
          )}
        </>
      ) : (
        <HELOCTerms
          recalculate={recalculate}
          content={content}
          helocOutput={state.helocOutput}
          key="output-section"
          setEquityError={(value) => dispatch({ type: 'SET_EQUITY_ERROR', payload: value })}
          helocUpdated={helocUpdated}
          ref={ref}
        />
      )}
    </>
  )
}
